import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS  } from '@angular/common/http';
// applications individual modules
import { ApplicationModule } from './application/application.module';
import { ScheduleModule } from './schedule/schedule.module';
import { AgendaModule } from './agenda/agenda.module';
import { MinutesModule } from './minutes/minutes.module';
import { SystemModule } from './system/system.module';
import { ReportsModule } from './reports/reports.module';
//import { LoginComponent } from './login/login.component';
import { NoticesModule } from './notices/notices.module';
// navigation/menus
import { AppTopbarComponent } from './app.topbar.component';
// e-Filing module
import { EfilingModule } from './efiling/efiling.module';
// third party modules
// import { ProgressSpinnerModule } from 'primeng/progressspinner';

// basic components
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
// Services, etc
import { CaseService } from './services/case.service';
import { SystemService } from './services/system.service';
import { ScheduleService } from './services/schedule.service';
import { DictionaryService } from './services/dictionary.service';
import { EfileService } from './services/efile.service';
import { UtilitiesService } from './services/utilities.service';
import { ReportService } from './services/report.service';
import { StatsService } from './services/stats.service';
import { LoginRouteGuard } from 'src/app/login-route-guard';
import { CookieService } from 'ngx-cookie-service';
import { AuthButtonComponent } from './shared/login/auth-button/auth-button.component';
import { EmailService } from './services/email.service';
import { EventEmitterService } from './services/event-emitter.service';
import { InactivityService } from './services/inactivity.service';

import * as theGlobals from './shared/globals';
import { LoggedInUserDto } from './shared/dto/LoggedInUserDto';

// Auth0
// import { AuthModule, AuthHttpInterceptor } from '@auth0/auth0-angular';

// MSAL
import { MsalModule, MsalRedirectComponent, MsalGuard, MSAL_INSTANCE, MsalService, MsalInterceptorConfiguration, MsalInterceptor, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular'; // MsalGuard added to imports
import { PublicClientApplication, InteractionType, IPublicClientApplication } from '@azure/msal-browser';
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {MessagesModule} from "primeng/messages";
import {ToastModule} from "primeng/toast";
import {ProgressSpinnerModule} from "primeng/progressspinner"; // InteractionType added to imports


export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: theGlobals.setEnv().clientIdUI,
      authority: theGlobals.setEnv().authority,
      // redirectUri: 'http://localhost:4200'
      redirectUri: window.location.origin
    }
  })
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  const myApiUrl = theGlobals.setEnv().funcUrl;
  protectedResourceMap.set(myApiUrl, [theGlobals.setEnv().AzureApiUrl]); // SB test api
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}
@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        //LoginComponent,
        AppTopbarComponent,
        AuthButtonComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        ApplicationModule,
        AgendaModule,
        ScheduleModule,
        MinutesModule,
        NoticesModule,
        RouterModule.forRoot([
            //{ path: 'login', component: LoginComponent },
            {path: 'home', component: HomeComponent},
            {path: 'splash', component: AppComponent},
            // { path: '', redirectTo: 'login', pathMatch: 'full'},
            // { path: '**', redirectTo: 'login', pathMatch: 'full'}
            {path: '', redirectTo: 'splash', pathMatch: 'full'},
            {path: '**', redirectTo: 'home', pathMatch: 'full'}
        ], {relativeLinkResolution: 'legacy'}),

        SystemModule,
        EfilingModule,
        ReportsModule,
        MsalModule,
        ConfirmDialogModule,
        MessagesModule,
        ToastModule,
        ProgressSpinnerModule,
        // ProgressSpinnerModule,
    ],
    providers: [
        SystemService,
        CaseService,
        ScheduleService,
        DictionaryService,
        EfileService,
        UtilitiesService,
        CookieService,
        ReportService,
        StatsService,
        EmailService,
        LoginRouteGuard,
        LoggedInUserDto,
      {
        provide: MSAL_INSTANCE,
        useFactory: MSALInstanceFactory
      },
      MsalService,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true
      },
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: MSALInterceptorConfigFactory
      },
      MsalGuard,
      EventEmitterService,
      InactivityService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
